import moment from "moment";

const DocumentsToRequireValidator = (t) => {
    moment.locale("es");
    let regexs = {
        documentNameRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.¿?]+$/),
        documentDescriptionRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.¿?]+$/),
    };

    let validators = {
        documentNameValidator: (value) => {
            if (value !== "" && value !== undefined) {
                if (value.length > 0) {
                    return regexs.documentNameRegex.test(value)
                        ? ""
                        : t("signature.request.emailValidator");
                }
            } else {
                return t("signature.request.emailValidatorNull");
            }
        },
        documentDescriptionValidator: (value) => {
            if (value.length > 0) {
                return regexs.documentDescriptionRegex.test(value)
                    ? ""
                    : t("signature.request.emailValidator");
            } else {
                return ""; // acepta vacío
            }
        }
    };
    return validators;
};

export default DocumentsToRequireValidator;
